interface CardItem {
  image: string;
  title: string;
  tag: string;
  desc: string;
  time: string;
}

const cardItems: CardItem[] = [
  {
    image: 'https://readdy.ai/api/search-image?query=A%20stylized%20illustration%20of%20a%20breaking%20news%20concept%20with%20newspaper%20and%20magnifying%20glass%2C%20warm%20red%20accents%2C%20editorial%20collage%20style%2C%20minimal%20composition%20on%20cream%20background%2C%20modern%20design&width=640&height=400&seq=card-01&orientation=landscape',
    title: '某当红艺人隐婚生子被拍，工作室连夜发声明',
    tag: '独家猛料',
    desc: '狗仔队蹲守多日拍到该艺人与神秘女子及幼童同行的画面，工作室在照片曝光后三小时内紧急发布声明。',
    time: '30分钟前',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20modern%20artistic%20representation%20of%20social%20media%20controversy%20with%20speech%20bubbles%20and%20exclamation%20marks%2C%20warm%20amber%20and%20red%20color%20palette%2C%20clean%20graphic%20design%2C%20editorial%20illustration%20style&width=640&height=400&seq=card-02&orientation=landscape',
    title: '大V博主实名举报某平台数据造假内幕',
    tag: '网曝门事件',
    desc: '拥有百万粉丝的知名博主发长文实名举报某社交平台存在系统性数据造假行为，引起业内广泛关注。',
    time: '2小时前',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=An%20elegant%20editorial%20illustration%20of%20celebrity%20gossip%20and%20entertainment%20industry%20secrets%2C%20dramatic%20shadows%20and%20warm%20golden%20highlights%2C%20sophisticated%20magazine%20cover%20style%2C%20cream%20background&width=640&height=400&seq=card-03&orientation=landscape',
    title: '热门IP改编剧选角引争议，原著粉集体抵制',
    tag: '今日黑料',
    desc: '某知名小说IP改编电视剧公布了主演阵容后，原著粉丝因选角与角色人设不符发起大规模抵制行动。',
    time: '4小时前',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20conceptual%20illustration%20of%20a%20leaked%20document%20with%20confidential%20stamp%2C%20dramatic%20lighting%2C%20warm%20red%20accents%2C%20investigative%20journalism%20aesthetic%2C%20modern%20editorial%20design%20on%20light%20background&width=640&height=400&seq=card-04&orientation=landscape',
    title: '某公司内部邮件泄露：高管言论引发舆论风暴',
    tag: '最新内幕',
    desc: '一封某知名企业高管的内部邮件被员工截图转发，其中涉及的不当言论在网络上迅速发酵。',
    time: '6小时前',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20creative%20editorial%20illustration%20of%20a%20gossip%20news%20scene%20with%20megaphone%20and%20headlines%2C%20warm%20amber%20gradient%2C%20dynamic%20composition%2C%20magazine%20layout%20style%2C%20cream%20background&width=640&height=400&seq=card-05&orientation=landscape',
    title: '电竞圈知名战队内部矛盾曝光，核心成员或离队',
    tag: '吃瓜爆料',
    desc: '联赛休赛期某顶级战队传出内部不和的消息，据知情人士透露已有核心选手与管理层产生严重分歧。',
    time: '8小时前',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1100px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            精选爆料
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            编辑精选，值得关注的爆料内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {cardItems.slice(0, 3).map((item, idx) => (
            <div
              key={idx}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all cursor-pointer"
            >
              <div className="aspect-[16/10] overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-4">
                <div className="flex items-center gap-2 mb-2">
                  <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs bg-primary-100 text-primary-700 whitespace-nowrap">
                    {item.tag}
                  </span>
                  <span className="text-xs text-foreground-400">{item.time}</span>
                </div>
                <h3 className="font-semibold text-foreground-900 text-sm mb-2 line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-foreground-500 text-xs leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}

          {/* Remaining 2 in a different layout */}
          {cardItems.slice(3).map((item, idx) => (
            <div
              key={idx + 3}
              className="sm:col-span-2 lg:col-span-2 group rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all cursor-pointer flex flex-col sm:flex-row"
            >
              <div className="sm:w-2/5 aspect-[16/10] sm:aspect-auto overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="flex-1 p-4 flex flex-col justify-center">
                <div className="flex items-center gap-2 mb-2">
                  <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs bg-primary-100 text-primary-700 whitespace-nowrap">
                    {item.tag}
                  </span>
                  <span className="text-xs text-foreground-400">{item.time}</span>
                </div>
                <h3 className="font-semibold text-foreground-900 text-sm md:text-base mb-2">
                  {item.title}
                </h3>
                <p className="text-foreground-500 text-xs md:text-sm leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}